// extracted by mini-css-extract-plugin
module.exports = {"button":"copy-to-clipboard-button_button__wMLEl","copied":"copy-to-clipboard-button_copied__G81_y","customText":"copy-to-clipboard-button_customText__HKKC6"};